module.exports = __webpack_public_path__ + "img/meguru03.c7d95865.png";